import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Plot from "react-plotly.js";
import React, { useEffect, useState } from "react";
import {
  getBoxplotAnalyze,
  getConfusionMatrix,
  getFeatureImportancePlot,
  getHistogramplot,
  getScatterplotAnalyze,
  getScatterplotTime,
  getAFSBarChart,
  getScatterplotAFS,
} from "../utils/plotting";

function Plotting(props) {
  const [plotData, setPlotData] = useState([]);
  const [plotLayout, setPlotLayout] = useState({});

  const theme = useTheme();
  const { t } = useTranslation();

  const plotGenerators = {
    boxAnalyze: getBoxplotAnalyze,
    scatterAnalyze: getScatterplotAnalyze,
    confusionMatrixVal: getConfusionMatrix,
    confusionMatrixTrain: getConfusionMatrix,
    scatterTime: getScatterplotTime,
    histogram: getHistogramplot,
    featureImportance: getFeatureImportancePlot,
    AFSHeatmap: getAFSBarChart,
    AFSScatter: getScatterplotAFS,
    // Add more plot types and their corresponding generator functions
  };

  const generatePlot = () => {
    const { type } = props;
    const plotGenerator = plotGenerators[type];
    if (plotGenerator) {
      const plot = plotGenerator(props, t, theme);
      setPlotLayout(plot[1]);
      setPlotData(plot[0]);
    }
  };

  useEffect(() => {
    generatePlot();
  }, [props.type, props.runData]);

  return (
    <>
      {plotData.length > 0 ? (
        <div
          style={{
            maxHeight: "700px",
            overflowY: "auto",
            overflowX: "hidden",
            width: "100%",
            maxWidth: "100%",
          }}
        >
          <Plot
            data={plotData}
            layout={plotLayout}
            config={{ responsive: true }}
            style={{ width: "100%", height: "100%" }} // ✅ Enforce plot scaling
            useResizeHandler
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Plotting;
